import angular, { IDirective, IScope } from "angular";

export const vsDirectiveName = "externalLoginFlow";

export function externalLoginFlow(): IDirective {
  return {
    restrict: "A",
    scope: false,
    link: {
      post: (scope: IScope) => {
        const authProvider = <AuthProvider>(<any>scope).authProvider;
        const linkElement = <HTMLAnchorElement>(
          (<any>angular.element)("<a></a>")[0]
        );

        linkElement.href = `/api/auth/${authProvider.Name}`;

        const clickHandler = () => linkElement.click();
        (<any>scope).startFlow = clickHandler;
      },
    },
  };
}
const inject: string[] = [];
externalLoginFlow.$inject = inject;
